/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/
import Vue from 'vue';
import Quasar from 'quasar/src/vue-plugin.js';import QAjaxBar from 'quasar/src/components/ajax-bar/QAjaxBar.js';import QLayout from 'quasar/src/components/layout/QLayout.js';import QHeader from 'quasar/src/components/header/QHeader.js';import QDrawer from 'quasar/src/components/drawer/QDrawer.js';import QPageContainer from 'quasar/src/components/page/QPageContainer.js';import QPage from 'quasar/src/components/page/QPage.js';import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';import QBtn from 'quasar/src/components/btn/QBtn.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QList from 'quasar/src/components/item/QList.js';import QItem from 'quasar/src/components/item/QItem.js';import QItemSection from 'quasar/src/components/item/QItemSection.js';import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import QBanner from 'quasar/src/components/banner/QBanner.js';import QCard from 'quasar/src/components/card/QCard.js';import QCardSection from 'quasar/src/components/card/QCardSection.js';import QSeparator from 'quasar/src/components/separator/QSeparator.js';import QCardActions from 'quasar/src/components/card/QCardActions.js';import QField from 'quasar/src/components/field/QField.js';import QInput from 'quasar/src/components/input/QInput.js';import QSpinner from 'quasar/src/components/spinner/QSpinner.js';import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';import QTable from 'quasar/src/components/table/QTable.js';import QTd from 'quasar/src/components/table/QTd.js';import QChip from 'quasar/src/components/chip/QChip.js';import QUploader from 'quasar/src/components/uploader/QUploader.js';import QTabs from 'quasar/src/components/tabs/QTabs.js';import QTab from 'quasar/src/components/tabs/QTab.js';import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';import QRouteTab from 'quasar/src/components/tabs/QRouteTab.js';import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import QRadio from 'quasar/src/components/radio/QRadio.js';import QDate from 'quasar/src/components/date/QDate.js';import QTime from 'quasar/src/components/time/QTime.js';import QSelect from 'quasar/src/components/select/QSelect.js';import QMenu from 'quasar/src/components/menu/QMenu.js';import QToggle from 'quasar/src/components/toggle/QToggle.js';import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';import QEditor from 'quasar/src/components/editor/QEditor.js';import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import QVideo from 'quasar/src/components/video/QVideo.js';import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';import QStepper from 'quasar/src/components/stepper/QStepper.js';import QStep from 'quasar/src/components/stepper/QStep.js';import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';import QFooter from 'quasar/src/components/footer/QFooter.js';import QScrollObserver from 'quasar/src/components/scroll-observer/QScrollObserver.js';import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';import QDialog from 'quasar/src/components/dialog/QDialog.js';import QAvatar from 'quasar/src/components/avatar/QAvatar.js';import QSpace from 'quasar/src/components/space/QSpace.js';import QBadge from 'quasar/src/components/badge/QBadge.js';import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';import QImg from 'quasar/src/components/img/QImg.js';import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';import QTimeline from 'quasar/src/components/timeline/QTimeline.js';import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';import QSplitter from 'quasar/src/components/splitter/QSplitter.js';import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';import QSlider from 'quasar/src/components/slider/QSlider.js';import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';import QRating from 'quasar/src/components/rating/QRating.js';import Ripple from 'quasar/src/directives/Ripple.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';import Meta from 'quasar/src/plugins/Meta.js';import Notify from 'quasar/src/plugins/Notify.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';import BottomSheet from 'quasar/src/plugins/BottomSheet.js';;
Vue.use(Quasar, {
  config: {},
  components: {
    QAjaxBar: QAjaxBar,
    QLayout: QLayout,
    QHeader: QHeader,
    QDrawer: QDrawer,
    QPageContainer: QPageContainer,
    QPage: QPage,
    QToolbar: QToolbar,
    QToolbarTitle: QToolbarTitle,
    QBtn: QBtn,
    QIcon: QIcon,
    QList: QList,
    QItem: QItem,
    QItemSection: QItemSection,
    QItemLabel: QItemLabel,
    QBanner: QBanner,
    QCard: QCard,
    QCardSection: QCardSection,
    QSeparator: QSeparator,
    QCardActions: QCardActions,
    QField: QField,
    QInput: QInput,
    QSpinner: QSpinner,
    QSpinnerGears: QSpinnerGears,
    QMarkupTable: QMarkupTable,
    QTable: QTable,
    QTd: QTd,
    QChip: QChip,
    QUploader: QUploader,
    QTabs: QTabs,
    QTab: QTab,
    QTabPanels: QTabPanels,
    QTabPanel: QTabPanel,
    QRouteTab: QRouteTab,
    QTooltip: QTooltip,
    QCheckbox: QCheckbox,
    QRadio: QRadio,
    QDate: QDate,
    QTime: QTime,
    QSelect: QSelect,
    QMenu: QMenu,
    QToggle: QToggle,
    QBtnGroup: QBtnGroup,
    QBtnToggle: QBtnToggle,
    QEditor: QEditor,
    QExpansionItem: QExpansionItem,
    QLinearProgress: QLinearProgress,
    QInnerLoading: QInnerLoading,
    QVideo: QVideo,
    QBreadcrumbs: QBreadcrumbs,
    QBreadcrumbsEl: QBreadcrumbsEl,
    QStepper: QStepper,
    QStep: QStep,
    QOptionGroup: QOptionGroup,
    QStepperNavigation: QStepperNavigation,
    QBtnDropdown: QBtnDropdown,
    QPageSticky: QPageSticky,
    QFooter: QFooter,
    QScrollObserver: QScrollObserver,
    QScrollArea: QScrollArea,
    QCarousel: QCarousel,
    QCarouselSlide: QCarouselSlide,
    QCarouselControl: QCarouselControl,
    QDialog: QDialog,
    QAvatar: QAvatar,
    QSpace: QSpace,
    QBadge: QBadge,
    QSlideTransition: QSlideTransition,
    QImg: QImg,
    QChatMessage: QChatMessage,
    QTimeline: QTimeline,
    QTimelineEntry: QTimelineEntry,
    QPopupEdit: QPopupEdit,
    QSplitter: QSplitter,
    QPopupProxy: QPopupProxy,
    QSlider: QSlider,
    QSkeleton: QSkeleton,
    QRating: QRating
  },
  directives: {
    Ripple: Ripple,
    ClosePopup: ClosePopup
  },
  plugins: {
    Meta: Meta,
    Notify: Notify,
    Dialog: Dialog,
    Loading: Loading,
    BottomSheet: BottomSheet
  }
});